// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageContent_image__w3k0U","imageFull":"ImageContent_imageFull__aK72C","caption":"ImageContent_caption__8Hu9t","showCaption":"ImageContent_showCaption__JpJAE"};